import {BaseDao} from "../BaseDao";
import {ApiHelper} from "../../apiHelper";
import {ConstantMan} from "../../constantMan";
import {Observable} from "rxjs";

export class EncodingDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.ENCODINGS, apiHelper);
    }

    public find(search: Object): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, search, headers);
    }

    public getEncodingsByAttribute(body: QueryEncodingsReq): Observable<QueryEncodingsRes> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/getEncodingsByAttribute';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, body, headers);
    }

    public searchEncodings(body: QueryEncodingsReq): Observable<QueryEncodingsRes> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/searchEncodings';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, body, headers);
    }
}

export interface QueryEncodingsReq {
    formatId: number;
    status: 'encoded' | 'queued';
    attributes?: { key: string, value: string }[];
    page?: number;
    pageSize?: number;
}

export interface QueryEncodingsRecord {
    _id: string;
    encodingId: number;
    formatId: number;
    encoderGroupId: number;
    encodedTimestamp: string;
    attributes: Object;
    cloneOf: number;
    detectionEndDate: string;
    aeisId: number;
    status: string;
    cloneFormatName: string;
    cloneFormatId: number;
    cloneCustomerName: string;
}

export interface QueryEncodingsRes {
    total: number;
    totalPages: number;
    data: QueryEncodingsRecord[];
}
